module.exports = __webpack_public_path__ + "img/link.62456595.png";